var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimcard = function SvgSimcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2C2D2E",
    clipPath: "url(#simcard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.172h9v7h-9z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#184BFF",
    d: "M19.54 20.252c0 .92-.705 1.685-1.601 1.78H5.71A1.71 1.71 0 0 1 4 20.322V4.392c0-.944.776-1.72 1.72-1.72h7.143l6.677 5.827zm-.4-11.35v-.227l-.171-.15-6.11-5.33-.142-.123H5.72c-.726 0-1.32.594-1.32 1.32v15.94c0 .726.584 1.31 1.31 1.31h12.04c.766 0 1.39-.624 1.39-1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.92 11.252H8.43c-1.16 0-2.1.94-2.1 2.09v4.62c0 1.16.94 2.09 2.1 2.09h6.49c1.16 0 2.1-.94 2.1-2.09v-4.62c0-1.16-.94-2.09-2.1-2.09m.7 2.09v1.61h-3.07v-2.31h2.37c.38 0 .7.31.7.7m-7.89 4.62v-4.62c0-.38.31-.7.7-.7h2.72v6.01H8.43c-.38 0-.7-.31-.7-.7zm7.19.7h-2.37v-2.31h3.07v1.61c0 .38-.31.7-.7.7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "simcard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5 2.172h16.54v20.36H3.5z"
  })))));
};
export default SvgSimcard;